import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { CompaniesDepartment, CompanyDepartmentType } from 'src/app/lem/models/departments/departments';
import { DepartmentsService } from '../../../service/departments.service';
import { CompanyService } from 'src/app/lem/pages/amministrazione/service/company.service';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { FormConfiguration } from 'src/app/core/components/dynamic-form/models/form-config';
import { Subscription, zip } from 'rxjs';
import { Company } from 'src/app/lem/models/companies/company';
import { ModalDepartmentFormComponent } from '../../../components/modal-department-form/modal-department-form.component';
import { searchConfig } from '../form-config/search-config';
import { map, filter } from 'rxjs/operators';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-gestione-dipartimenti',
  templateUrl: './gestione-dipartimenti.component.html',
  styleUrls: ['./gestione-dipartimenti.component.css'],
})
export class GestioneDipartimentiComponent implements OnInit ,OnDestroy {

  activeTab = 0;

  formFields: QuestionBase[] = []
  formConfiguration: FormConfiguration = {
    buttons: [
      {
        bg: "",
        width: "",
        type: "submit",
        title: "Ricerca",
        class: "btn-primary",
      },
      {
        bg: "",
        width: "",
        type: "reset",
        title: "Reset",
        class: "btn-secondary",
      }
    ]
  }

  totalItems : number;
  dipartments : PaginatedResponse<CompaniesDepartment>;
  companiesList : Company[] = [];
  types : CompanyDepartmentType[] = [];
  subscriptionRefresh : Subscription;
  pagable:Pagable;
  resetC
  searchParams: any;
  resetCurrentPage: boolean = false;

  constructor(private modal : DialogService,
    private departmentsService : DepartmentsService,
    private companyService : CompanyService,
    private viewManager : ViewManagerService) { }

  ngOnInit() {
    this.viewManager.svuotaMenu();

    this.pagable = new Pagable();

    this.formFields = searchConfig;
    this.getAllDepartments();

    const obsCompany = this.companyService.getAllCompany();

    const obsDepTypes = this.departmentsService.getAllTypes();


    const zipObs = zip(
      obsCompany,
      obsDepTypes
    );

    zipObs.subscribe({
      next:(data)=>{
        this.companiesList = data[0].items;
        this.types = data[1].items;
        this.onLoadData();
        },
      error:()=>{}
    });

    this.subscriptionRefresh = this.departmentsService.RefreshRequired$
    .subscribe(()=>{
      this.getAllDepartments();
    })
  }

  private getAllDepartments() {
    this.departmentsService.getAll(undefined,undefined, this.pagable).subscribe({
      next: (data) => {
        this.dipartments = data;
      },
      error: (error) => { console.log(JSON.stringify(error))}
    });
  }

  private getDepartmentsZip() {
    const obsDeps = this.departmentsService.getAll(undefined,undefined, this.pagable);
    const obsDepTypes = this.departmentsService.getAllTypes();
    const zipObs = zip(
      obsDeps,
      obsDepTypes
    );

    zipObs.subscribe({
      next:(data)=>{
        this.dipartments = data[0];
        this.types = data[1].items;
        this.onLoadData();
        },
      error:()=>{}
    });
  }

  ngOnDestroy(): void {
    if(this.subscriptionRefresh) this.subscriptionRefresh.unsubscribe();
  }

  onLoadData() {
    this.formFields = this.formMapper(searchConfig);
  }

  formMapper (config : QuestionBase[]) {
    const indexCompanies = config.findIndex(el => el.key === "company.id");
    config = this.elementMapper(config,this.companiesList,indexCompanies);
    const indexType = config.findIndex(el => el.key === "id");
    return this.elementMapper(config,this.types,indexType);
  }

  private elementMapper(fields: QuestionBase[], data : any , indexTipo : number) {
    fields[indexTipo].options = data.map(el => {
      return {
        key: el.id,
        value: el,
        label: el.name
      };
    });
    return fields;
  }

  getAllCompanyDepartments () {
    this.departmentsService.getAll(undefined,undefined, this.pagable).subscribe({
      next:(data)=>{
        this.dipartments = data;
      },
      error:()=>{}
    });
  }

  onEdit(companyDepartment: CompaniesDepartment){
    const ref = this.modal.open(ModalDepartmentFormComponent,{
      data : {
        companies : this.companiesList,
        types : this.types,
        style: {width: "50%"},
        dipartmentsList : this.dipartments.items,
        department : companyDepartment,
        formSettings : {
          formEdit : true,
          formData : ""
        }
      }
    })
    this.modalCloseEvent(ref);
  }

  onDelete(companyDepartment: CompaniesDepartment){
    const ref = this.modal.open(ConfirmModalComponent,{
      data : {
        modalConfirm:{

          text:"Eliminare il dipartimento  " + companyDepartment.name + "?" ,
          data : companyDepartment,
        },
        style: {width: "30%"},
        title:"Eliminazione Dipartimento",
      }
    })
    this.modalCloseEvent(ref);
  }

  addDepartment () {
    const ref = this.modal.open(ModalDepartmentFormComponent,{
      data : {
        companies : this.companiesList,
        types : this.types,
        style: {width: "50%"},
        dipartmentsList : this.dipartments.items,
        formSettings : {
          formEdit : false,
          formData : ""
        }
      }
    })

    this.modalCloseEvent(ref);
  }

  modalCloseEvent(ref: DialogRef) {
    ref.afterClosed.pipe(
      filter(response => response)
    ).subscribe((data)=>{
      if (data.save){
        this.departmentsService.bulk(data.data).pipe(
          map(data=> this.getDepartmentsZip())
        ).subscribe();
      } else if (data.modalEvent){
        this.departmentsService.delete(data.data.joinId).pipe(
          map(data => this.getDepartmentsZip())
        ).subscribe();
      }
    });
  }

  sendSearch (searchParams, pagable?: Pagable) {
    if(!pagable) {
      this.pagable.page = 0;
    }
    this.resetCurrentPage = true;
    this.searchParams = searchParams;
    this.departmentsService.getAll(this.cleanEmpty(searchParams), undefined, this.pagable).subscribe((res)=>{
      this.dipartments = res;
    });
  }

  cleanEmpty (obj) {
    for (let propName in obj) {
      if (!obj[propName]) {
        delete obj[propName];
      }
    }
    return obj
  }

  retrievePagable(pagable:Pagable){
    this.pagable = pagable;
    this.getAllCompanyDepartments();
  }

  refresh(pagination?: Pagination) {
    if (pagination) {
      this.pagable.size = pagination.getItemsPerPage();
      this.pagable.page = pagination.getCurrentPage();
    }
    this.sendSearch(this.searchParams, this.pagable);
    this.resetCurrentPage = false;
  }
}
